export default {
  NEXT_AND_CANCEL: 'NEXT_AND_CANCEL',
  NEXT: 'NEXT',
  OK: 'OK',
  OK_AND_CLOSE: 'OK_AND_CLOSE',
  LOGIN_REQUIRED: 'LOGIN_REQUIRED',
};
